import log from '../api/logger';

/*
    This reducer is currently not tested due to lack of functionality.
    It is filtered out in gulpfile.js
*/
function logToServer(store, action = {payload: {data: {}}}) {
    const {payload} = action;

    log(payload.data);
}

export default logToServer;
export {logToServer};
